import { render, staticRenderFns } from "./ContentLabelQa.vue?vue&type=template&id=41ce6229&scoped=true"
import script from "./ContentLabelQa.vue?vue&type=script&lang=js"
export * from "./ContentLabelQa.vue?vue&type=script&lang=js"
import style0 from "./ContentLabelQa.vue?vue&type=style&index=0&id=41ce6229&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ce6229",
  null
  
)

export default component.exports